import { createSlice } from '@reduxjs/toolkit';

import { useActions as useActionsUtil } from '../../utils/actions';
import reducers, { initialState } from './reducers';

const scanSessionSlice = createSlice({
	name: 'scanSession',
	reducers,
	initialState,
});

export const useActions = () => useActionsUtil(scanSessionSlice.actions);

export default scanSessionSlice;

export const { actions, reducer } = scanSessionSlice;

export const scanSessionReducer = reducer;
